var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-tooltip",
    {
      attrs: {
        disabled: !_vm.disabled,
        content: _vm.$t(
          "pc_kng_courseware_tip_connect_to_server" /**无法连接到服务器，如需访问请联系管理人员，检查服务器是否启动 */
        ),
        placement: "top",
      },
    },
    [
      _c(
        "span",
        [
          _vm.showUpload
            ? _c(
                "yxtbiz-upload",
                {
                  ref: "bizUpload",
                  attrs: {
                    isBizMixDeploy: true,
                    isLocal: _vm.isPrivate,
                    localGroupId: "" + (_vm.isPrivate ? _vm.serverGroupId : ""),
                    source: "501",
                    "app-code": "kng",
                    "config-key": _vm.isHtmlAndScorm
                      ? "ZipConfigKey"
                      : "KnowledgeConfigKey",
                    "module-name": "knowledgefiles",
                    "function-name": "files",
                    "icon-class": "icon-upload",
                    fileType: _vm.specialFileType_ || _vm.specialFileType,
                    filters: _vm.isHtmlAndScorm ? ".zip" : _vm.filters,
                    "files-filter": _vm.filesFilter,
                    "files-added": _vm.filesAdded,
                    "before-upload": _vm.beforeUpload,
                    "on-network-speed": _vm.onNetworkSpeed,
                    "on-progress": _vm.onProgress,
                    "on-uploaded": _vm.onUploaded,
                    "on-error": _vm.onError,
                    drag: _vm.drag,
                    disabled: _vm.disabled,
                    md5: "",
                    multipe: _vm.multiple,
                  },
                },
                [
                  _vm.$slots.default
                    ? [_vm._t("default")]
                    : _c("div", [
                        _c("i", {
                          staticClass:
                            "yxt-icon-upload color-gray-7 font-size-32",
                        }),
                        _c("div", { staticClass: "mt6 color-gray-10" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pc_biz_upload_lbl_drag_new" /**拖拽或点击此处选择文件 */
                              )
                            )
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "mt4 color-gray-6 standard-size-12" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.isHtmlAndScorm
                                    ? _vm.$t(
                                        "pc_biz_lbl_supportspecialkng2" /**支持：压缩文件，大小限制300M内 */,
                                        [this.htmlAndScormSize]
                                      )
                                    : _vm.enableUploadZip
                                    ? _vm.$t(
                                        "pc_biz_lbl_supportcommonkng2" /**支持：文档、图片、视频、音频、压缩文档 */
                                      )
                                    : _vm.$t(
                                        "pc_biz_lbl_supportcommonkng" /**支持：文档、图片、视频、音频 */
                                      )
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }